module.exports = __webpack_public_path__ + "img/05060000.73824057.svg";